export function cameFrom(router, location) {
  const previous = window.history.state?.back;
  if (typeof previous !== 'string') return false;
  return previous.split(/[?#]/)[0] === router.resolve(location).path;
}

export function backTo(router, location) {
  if (cameFrom(router, location)) router.back();
  else router.push(location);
}
